import { VerticalContainer } from '@american-autonomy/ag-ui';

import Card from 'components/Card';
import LabelText from 'components/text/LabelText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const WarrantyCard: FunctionComponent<Props> = ({
    className = '',
    description,
    subtitle,
    testId = TEST_ID,
    title
}) => (
    <Card className={`${className} ${styles.warrantyCard}`} testId={testId}>
        <VerticalContainer className={styles.warrantyCardContent}>
            <VerticalContainer className={styles.warrantyCardHeader}>
                <LabelText className={styles.warrantyCardTitle} text={title} />

                <LabelText className={styles.warrantyCardSubtitle} text={subtitle} />
            </VerticalContainer>

            <LabelText className={styles.warrantyCardDescription} text={description} />
        </VerticalContainer>
    </Card>
);

export default WarrantyCard;
